import { createContext } from 'react';

interface ISelfListingContextData {
    formik: any;
    isOrganizationDetailsFormDisabled: boolean;
    disabledForEditors: boolean;
}

export const SelfListingContext = createContext({} as ISelfListingContextData);
